/**
 * Pricing Table component.
 *
 * @package Schema_AI
 */

import { Card, CardBody, Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useUserContext } from '../../context/UserContext';

function PricingTable() {
	const { plan } = useUserContext();

	const plans = [
		{
			name: __( 'Free', 'schema-ai' ),
			price: '$0',
			period: __( 'forever', 'schema-ai' ),
			description: __( 'Try it out', 'schema-ai' ),
			features: [
				__( '30 AI generations/month', 'schema-ai' ),
				__( 'All schema types', 'schema-ai' ),
				__( 'Visual schema editor', 'schema-ai' ),
				__( 'Google Rich Results test', 'schema-ai' ),
				__( 'Analytics dashboard', 'schema-ai' ),
				__( '10 competitor URL analyses/month', 'schema-ai' ),
				__( 'Community support', 'schema-ai' ),
			],
			key: 'free',
		},
		{
			name: __( 'Pro', 'schema-ai' ),
			price: '$9.99',
			period: __( '/month', 'schema-ai' ),
			description: __( 'For your own website', 'schema-ai' ),
			yearlyNote: __( '$99.90/year — save 2 months', 'schema-ai' ),
			highlight: false,
			features: [
				__( '300 AI generations/month', 'schema-ai' ),
				__( 'Everything in Free', 'schema-ai' ),
				__( 'Auto-generate on publish', 'schema-ai' ),
				__( 'Bulk generation', 'schema-ai' ),
				__( 'Content gap analysis', 'schema-ai' ),
				__( '100 competitor URL analyses/month', 'schema-ai' ),
				__( 'Optimisation suggestions', 'schema-ai' ),
				__( 'Google Search Console integration', 'schema-ai' ),
				__( 'Priority email support', 'schema-ai' ),
			],
			key: 'pro',
		},
		{
			name: __( 'Premium', 'schema-ai' ),
			price: '$29',
			period: __( '/month', 'schema-ai' ),
			description: __( 'For client work & agencies', 'schema-ai' ),
			yearlyNote: __( '$290/year — save 2 months', 'schema-ai' ),
			highlight: true,
			features: [
				__( '1,000 AI generations/month', 'schema-ai' ),
				__( 'Everything in Pro', 'schema-ai' ),
				__( 'Unlimited competitor URL analyses', 'schema-ai' ),
				__( '5 sites included (+$5/extra site)', 'schema-ai' ),
				__( '3 team seats included (+$5/extra seat)', 'schema-ai' ),
				__( 'Dedicated support', 'schema-ai' ),
			],
			key: 'premium',
		},
	];

	return (
		<div className="schema-ai-pricing-table">
			<div className="schema-ai-pricing-grid">
				{ plans.map( ( p ) => (
					<Card
						key={ p.key }
						className={ `schema-ai-pricing-card ${ plan === p.key ? 'schema-ai-pricing-current' : '' } ${ p.highlight ? 'schema-ai-pricing-highlight' : '' }` }
					>
						<CardBody>
							{ p.highlight && <span className="schema-ai-pricing-popular">{ __( 'Most Popular', 'schema-ai' ) }</span> }
							<h3>{ p.name }</h3>
							{ p.description && <p className="schema-ai-pricing-description">{ p.description }</p> }
							<div className="schema-ai-pricing-price">
								<span className="schema-ai-price-amount">{ p.price }</span>
								<span className="schema-ai-price-period">{ p.period }</span>
							</div>
							{ p.yearlyNote && (
								<p className="schema-ai-price-yearly">{ p.yearlyNote }</p>
							) }
							<ul className="schema-ai-pricing-features">
								{ p.features.map( ( f, i ) => (
									<li key={ i }>
										<span className="dashicons dashicons-yes"></span>
										{ f }
									</li>
								) ) }
							</ul>
							{ plan === p.key ? (
								<Button variant="secondary" disabled className="schema-ai-pricing-btn">
									{ __( 'Current Plan', 'schema-ai' ) }
								</Button>
							) : p.key === 'free' ? null : (
								<Button variant="primary" href="https://aischemagen.com/pricing" target="_blank" className="schema-ai-pricing-btn">
									{ __( 'Upgrade Now', 'schema-ai' ) }
								</Button>
							) }
						</CardBody>
					</Card>
				) ) }
			</div>
		</div>
	);
}

export default PricingTable;
